module.exports = __webpack_public_path__ + "img/partner11.93cbdcc1.png";